import { Injectable } from '@angular/core';
import { Category } from '../interfaces/category.interface';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryLocalizationService {
  constructor(private languageService: LanguageService) {}

  /**
   * Get localized category name
   */
  getLocalizedName(category: Category | null): string {
    if (!category) return '';
    const lang = this.languageService.getCurrentLanguage() || 'en';
    return category.i18n?.[lang]?.name || category.name || '';
  }

  /**
   * Get localized sub-products
   */
  getLocalizedSubProducts(category: Category | null): string[] {
    if (!category) return [];
    const lang = this.languageService.getCurrentLanguage() || 'en';
    
    // Get sub-products from localized version first, then fallback to category sub-products
    const localizedSubProducts = category.i18n?.[lang]?.subProducts;
    const categorySubProducts = category.subProducts;
    const subProducts = localizedSubProducts || categorySubProducts;
    
    if (!subProducts) return [];
    
    // Handle both array and object formats
    if (Array.isArray(subProducts)) {
      return subProducts;
    }
    
    // If it's an object with numeric keys, convert to array
    if (typeof subProducts === 'object') {
      return Object.values(subProducts).filter((item): item is string => typeof item === 'string');
    }
    
    return [];
  }

  /**
   * Format localized sub-products for display (comma-separated)
   */
  formatLocalizedSubProducts(category: Category | null): string {
    const subProducts = this.getLocalizedSubProducts(category);
    if (subProducts.length === 0) return '';
    return subProducts.join(', ');
  }
}

